export default "__VITE_ASSET__D7h_W8_Z__"